export default __webpack_public_path__ + "static/media/emergencia.96de3abe.svg";